import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";

const Slide3 = (props) => {
  const [brancheState, setBrancheState] = useState(0);
  const [toggleHover, setToggleHover] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [clickedBranche, setClickedBranche] = useState();
  const [sousBranchePage, setSousBranchePage] = useState();

  const branchesContainerRef = useRef(null);
  const logoRef1 = useRef(null);
  const logoRef2 = useRef(null);
  const logoRef3 = useRef(null);
  const logoRef4 = useRef(null);

  const detailRef1 = useRef(null);
  const detailRef2 = useRef(null);
  const detailRef3 = useRef(null);
  const detailRef4 = useRef(null);

  const detailTextRef1 = useRef(null);
  const detailTextRef2 = useRef(null);
  const detailTextRef3 = useRef(null);
  const detailTextRef4 = useRef(null);

  const openBranche = (event) => {
    const branche = event.currentTarget; // focus de la branche sur laquelle l'utilisateur clique
    const container = branchesContainerRef.current; // focus du contener parent pour le translate
    const sousBranchePage = document.querySelector(".sousBranche"); // ouverture de la page sous branches

    setSousBranchePage(sousBranchePage); // set la page sou branche pour la fermeture de l'animation
    setClickedBranche(branche); // set la branche cliquer pour l'utiliser dans la fermeture de l'animation

    // condition d'affichage de la page sousBranches
    if (branche.id === "log") {
      setBrancheState(1);
    } else if (branche.id === "marines") {
      setBrancheState(2);
    } else if (branche.id === "flotte") {
      setBrancheState(3);
    }

    gsap.to(sousBranchePage, {
      display: "flex",
      width: "100%", // Largeur finale de l'élément
      height: "100%", // Hauteur finale de l'élément
      opacity: 0, // Opacité finale de l'élément
      duration: 0.5,
    });

    // Calculer les coordonnées globales de la branche cliquée
    const brancheBounds = branche.getBoundingClientRect();
    const containerBounds = container.getBoundingClientRect();

    // Calculer le décalage pour centrer la branche cliquée
    const offset =
      containerBounds.width / 2 -
      (brancheBounds.left - containerBounds.left) -
      brancheBounds.width / 2;

    // modifie légèrement l'animation dans le cas ou la branche du milieu est cliquer (le delay n'est pas nécéssaire)
    if (branche.id === "marines") {
      // Animer la branche cliquée une fois centrée
      gsap.to(branche, {
        duration: 0.5,
        zIndex: 1,
        scale: 3, // Grossissement de la branche
        opacity: 0, // Opacité de la branche
        onComplete: () => {
          gsap.to(sousBranchePage, {
            opacity: 1, // Opacité finale de l'élément
            duration: 0.5, // Durée totale de l'animation en secondes
            ease: "power3.in",
          });
        },
      });
    } else {
      // Animer le décalage horizontal de .branches
      gsap.to(".branches", {
        duration: 0.6,
        x: offset, // Appliquez la translation à .branches
        ease: "power2.out",
        onComplete: () => {
          gsap.to(sousBranchePage, {
            opacity: 1, // Opacité finale de l'élément
            duration: 0.3, // Durée totale de l'animation en secondes
            ease: "power3.in",
          });
        },
      });

      // Animer la branche cliquée une fois centrée
      gsap.to(branche, {
        duration: 0.6,
        zIndex: 1,
        scale: 3, // Grossissement de la branche
        opacity: 0, // Opacité de la branche
        delay: 0.3, // Attendre 0.3 seconde avant de commencer l'animation de la branche
      });
    }

    // Sélectionner tous les enfants sauf la branche cliquée
    const otherBranches = Array.from(container.children).filter(
      (child) => child !== branche
    );

    // Animer la disparition des autres branches
    gsap.to(otherBranches, {
      duration: 0.6,
      opacity: 0,
      delay: 0.3, // Attendre 0.3 seconde avant de commencer l'animation de disparition
    });
  };

  const closeBranche = (clickedDetailRef) => {
    setToggle(false); // reinitalise la popUp sous branche details
    document
      .querySelector(".sousBranche")
      .classList.remove("triggerSousBranche"); // retire un classe pour fermer la page de sous branche

    const container = branchesContainerRef.current; // focus div parent .branches pour le translate

    const branches = document.querySelectorAll(".slide3Cont__branchesCont"); // focus tout les enfants de container ( les 3 logo des branches)
    const otherBranches = Array.from(container.children).filter(
      (child) => child !== branches && !child.classList.contains("sousBranche")
    ); // filtre tout les enfant sauf celui sur lequel l'utilisateur clique

    gsap.to(sousBranchePage, {
      duration: 0.4,
      opacity: 0,

      ease: "power2.in",
      onComplete: () => {
        gsap.to(sousBranchePage, {
          width: 0,
          height: 0,
          display: "none",
        });
      },
    });

    // Annuler les animations actuelles et réinitialiser les propriétés à leurs valeurs d'origine
    gsap.to(otherBranches, {
      duration: 0.6,
      opacity: 1,
      scale: 1,
      delay: 0.4,
      x: 0,
      ease: "power2.out",
    });

    // Réinitialiser la branche cliquée pour la faire réapparaître

    if (clickedBranche.id === "marines") {
      gsap.to(clickedBranche, {
        duration: 0.9,
        display: "flex",
        opacity: 1,
        scale: 1,
      });
    } else {
      gsap.to(clickedBranche, {
        duration: 1.2,
        display: "flex",
        opacity: 1,
        scale: 1,
      });
    }

    const allDetailsTextRefs = [detailTextRef1, detailTextRef2, detailTextRef3];
    const allDetailsRefs = [detailRef1, detailRef2, detailRef3];
    allDetailsTextRefs.forEach((ref) => {
      if (ref) {
        gsap.to(ref.current, {
          opacity: 0,
          duration: 0.2,
          onComplete: () => {
            allDetailsRefs.forEach((refDetails) => {
              gsap.to(refDetails.current, {
                width: 0,
                opacity: 0,
                duration: 0.4,
                onComplete: () => {
                  // Réinitialiser l'état d'ouverture du détail
                  setToggle(false);

                  // Réinitialiser l'animation des images

                  const allRefs = [logoRef1, logoRef2, logoRef3];
                  allRefs.forEach((ref) => {
                    gsap.to(ref.current, {
                      x: 0,
                      y: 0,
                      opacity: 1,
                      scale: 1,
                      pointerEvents: "auto",
                      zIndex: 0,
                    });
                  });
                },
              });
            });
          },
        });
      }
    });
  };

  const openSousBrancheAnim = (clickedRef, clickedDetailRef) => {
    if (toggle) {
      return;
    }

    // Mettre à jour l'état pour indiquer que le détail est ouvert
    setToggle(true);

    // Récupérer les dimensions de l'écran
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Récupérer les dimensions et la position de l'image cliquée
    const imageWidth = clickedRef.current.offsetWidth;
    const imageHeight = clickedRef.current.offsetHeight;
    const imageRect = clickedRef.current.getBoundingClientRect();

    if (screenWidth <= 1024) {
      // Calculer la position au milieu de l'écran
      const translateX = (screenWidth - imageWidth) / 4.5 - imageRect.left;
      const translateY = (screenHeight - imageHeight) / 2 - imageRect.top;

      // Animer l'image cliquée vers le milieu de l'écran
      gsap.to(clickedRef.current, {
        x: translateX,
        y: translateY,
        scale: 1.4,
        zIndex: 1,
      });
    } else if (screenWidth <= 1440) {
      // Calculer la position au milieu de l'écran
      const translateX = (screenWidth - imageWidth) / 3.5 - imageRect.left;
      const translateY = (screenHeight - imageHeight) / 2 - imageRect.top;

      // Animer l'image cliquée vers le milieu de l'écran
      gsap.to(clickedRef.current, {
        x: translateX,
        y: translateY,
        scale: 1.5,
        zIndex: 1,
      });
    } else {
      // Calculer la position au milieu de l'écran
      const translateX = (screenWidth - imageWidth) / 3.5 - imageRect.left;
      const translateY = (screenHeight - imageHeight) / 2 - imageRect.top;

      // Animer l'image cliquée vers le milieu de l'écran
      gsap.to(clickedRef.current, {
        x: translateX,
        y: translateY,
        scale: 1.7,
        zIndex: 1,
      });
    }

    const allRefs = [logoRef1, logoRef2, logoRef3];
    allRefs.forEach((ref) => {
      if (ref !== clickedRef) {
        gsap.to(ref.current, {
          opacity: 0.2,
          scale: 0.9,
          pointerEvents: "none",
          zIndex: 0,
        });
      }
    });

    gsap.to(clickedDetailRef.current, {
      width: 500,
      opacity: 1,
      onComplete: () => {
        const allDetailsTextRefs = [
          detailTextRef1,
          detailTextRef2,
          detailTextRef3,
        ];
        allDetailsTextRefs.forEach((ref) => {
          if (ref !== clickedDetailRef) {
            gsap.to(ref.current, {
              opacity: 1,
            });
          }
        });
      },
    });

    const allDetailsRefs = [logoRef1, logoRef2, logoRef3];
    allDetailsRefs.forEach((ref) => {
      if (ref !== clickedDetailRef) {
        gsap.to(ref.current, {
          width: 0,
        });
      }
    });
  };

  const closeSousBrancheAnim = (clickedDetailRef) => {
    const allDetailsTextRefs = [
      detailTextRef1,
      detailTextRef2,
      detailTextRef3,
      detailTextRef4,
    ];
    allDetailsTextRefs.forEach((ref) => {
      if (ref !== clickedDetailRef) {
        gsap.to(ref.current, {
          opacity: 0,
          duration: 0.2,
          onComplete: () => {
            gsap.to(clickedDetailRef.current, {
              width: 0,
              opacity: 0,
              duration: 0.4,
              onComplete: () => {
                // Réinitialiser l'état d'ouverture du détail
                setToggle(false);

                // Réinitialiser l'animation des images

                const allRefs = [logoRef1, logoRef2, logoRef3, logoRef4];
                allRefs.forEach((ref) => {
                  gsap.to(ref.current, {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    scale: 1,
                    pointerEvents: "auto",
                    zIndex: 0,
                  });
                });
              },
            });
          },
        });
      }
    });
  };

  return (
    <div className="slide3Cont" ref={branchesContainerRef}>
      <div ref={branchesContainerRef} className="branches">
        <div
          className="slide3Cont__branchesCont flotte"
          id="flotte"
          onClick={openBranche}
        >
          <h3 className="brancheTitle">Flotte</h3>
          <img
            className="slide3Cont__branchesCont__ecusson"
            src="../../../images/vitrine/slide3/Logos_FCU_Flotte.png"
            alt="V logistique"
          />
        </div>

        <div
          className="slide3Cont__branchesCont marines "
          id="marines"
          onClick={openBranche}
        >
          <h3 className="brancheTitle">Marines</h3>
          <img
            className="slide3Cont__branchesCont__ecusson"
            src="../../../images/vitrine/slide3/Logos_FCU_Marines.png"
            alt="V logistique"
          />
        </div>
        <div
          className={`slide3Cont__branchesCont log`}
          id="log"
          onClick={openBranche}
        >
          <h3 className="brancheTitle">POLYTECH</h3>
          <img
            className="slide3Cont__branchesCont__ecusson"
            src="../../../images/vitrine/slide3/Logos_FCU_Polytech.png"
            alt="V logistique"
          />
        </div>
      </div>

      <div className="sousBranche" id="sousBranche">
        {brancheState === 1 && (
          <div className="sousBranche__sousBrancheCont">
            <div className="sousBranche__sousBrancheCont__header">
              <span>
                <img
                  src="../../../images/vitrine/logo/logoLog.png"
                  alt="logo de la logistique"
                />
                <h2>Logistique</h2>
              </span>
              <button onClick={closeBranche}>
                {" "}
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>
            <p className="brancheDescription">
              La Logistique de la FCU est sa branche la plus importante. Sa
              mission est de permettre la soutenabilité des opérations
              militaires en assurant les réapprovisionnements et réparations des
              actifs mis en œuvre mais également d'utiliser ses capacités
              industrielles afin de garantir la bonne santé financière de la
              corporation.
            </p>

            <div className="sousBranche__sousBrancheCont__logoCont">
              <div className="sousBranche__sousBrancheCont__logoCont__logo">
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef1, detailRef1)}
                    ref={logoRef1}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/RH.png"
                      alt="logo des sous branches"
                    />
                    <h3>Admin logistique</h3>
                    <div className="sousBrancheDetails" ref={detailRef1}>
                      <div className="detailTitle">
                        <h2>ADMIN</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef1)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef1} className="textCont">
                          <p>
                            L'ADMIN est en charge de la gestion des stocks, de
                            la comptabilité, du versement des soldes ainsi que
                            des affectations des membres.{" "}
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef2, detailRef2)}
                    ref={logoRef2}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/ACTIF.png"
                      alt="logo des sous branches"
                    />
                    <h3>Industrie militaire</h3>
                    <div className="sousBrancheDetails" ref={detailRef2}>
                      <div className="detailTitle">
                        <h2>&emsp;&emsp;&emsp;INMIL</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef2)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef2} className="textCont">
                          <p>
                            L'INMIL est la division qui supervise l'exploitation
                            des ressources, leur transformation et la crafting
                            dans le but d'obtenir une autonomie matérielle et
                            les meilleurs composants pour la guerre.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef3, detailRef3)}
                    ref={logoRef3}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/Admin.png"
                      alt="logo des sous branches"
                    />
                    <h3>Gestion des actifs</h3>
                    <div className="sousBrancheDetails" ref={detailRef3}>
                      <div className="detailTitle">
                        <h2>ACTIFS</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef3)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef3} className="textCont">
                          <p>
                            La division ACTIFS forme et encadre l’ensemble des
                            opérateurs de l'organisation. Elle a pour mission de
                            pousser toujours plus loin la rentabilité des
                            activités industrielles de l'organisation.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        )}

        {brancheState === 2 && (
          <div className="sousBranche__sousBrancheCont">
            <div className="sousBranche__sousBrancheCont__header">
              <span>
                <img
                  src="../../../images/vitrine/logo/logoMarines.png"
                  alt="logo de la logistique"
                />
                <h2>Marines</h2>
              </span>
              <button onClick={closeBranche}>
                {" "}
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>
            <p className="brancheDescription">
              L'un des pilliers de la corporation. Que cela soit au sol ou dans
              l'espace, via des gunship ou des blindés les Marines combattent,
              inculpant les valeurs de la FCU à leurs ennemis.
            </p>

            <div className="sousBranche__sousBrancheCont__logoCont">
              <div className="sousBranche__sousBrancheCont__logoCont__logo">
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef1, detailRef1)}
                    ref={logoRef1}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/VAA.png"
                      alt="logo des sous branches"
                    />
                    <h3>Vecteur d'appuis Aérospatiale</h3>
                    <div className="sousBrancheDetails" ref={detailRef1}>
                      <div className="detailTitle">
                        <h2>V.A.A</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef1)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef1} className="textCont">
                          <p>
                            La VAA met en oeuvre les Dropships qui permettent
                            aux Marines d'être déployés partout rapidement.
                            Qu'il s'agisse d'un groupe d'assaut, d'un binôme
                            reco ou d'un groupe Meca. La VAA intervient la
                            plupart du temps directement sous le feu ennemi, ou
                            à l'inverse dans le noir le plus total.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>

                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef2, detailRef2)}
                    ref={logoRef2}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/Infanterie Mécanisée.png"
                      alt="logo des sous branches"
                    />
                    <h3>Infanterie Mécanisée</h3>
                    <div className="sousBrancheDetails" ref={detailRef2}>
                      <div className="detailTitle">
                        <h2>I.M.C.B</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef2)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef2} className="textCont">
                          <p>
                            L'infanterie mécanisée est pourvue de moyens blindés
                            lourds ainsi que de véhicules spécialisés : Rovers
                            et Snubs légers de reconnaissance ou d'assaut
                            rapide, ou véhicules lance-missiles comme le
                            Ballista.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>

                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef3, detailRef3)}
                    ref={logoRef3}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/Infanterie.png"
                      alt="logo des sous branches"
                    />
                    <h3>Infanterie Coloniale</h3>
                    <div className="sousBrancheDetails" ref={detailRef3}>
                      <div className="detailTitle">
                        <h2>I.M.C</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef3)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef3} className="textCont">
                          <p>
                            Les Marines de l'Infanterie assurent des missions
                            d'assaut, de défense et de destruction, sur terre et
                            dans l'espace. Au cœur de l'action, ils bénéficient
                            d'un soutien mécanisé et de capacités de transport
                            rapide.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        )}

        {brancheState === 3 && (
          <div className="sousBranche__sousBrancheCont">
            <div className="sousBranche__sousBrancheCont__header">
              <span>
                <img
                  src="../../../images/vitrine/logo/logoFlotte.png"
                  alt="logo de la logistique"
                />
                <h2>Flotte</h2>
              </span>
              <button onClick={closeBranche}>
                {" "}
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>
            <p className="brancheDescription">
              Fer de lance de la FCU, la flotte regroupe l'ensemble des unités
              de combat aérospatiale. Puissante, elle est la principale force de
              frappe de l'organisation et nous permettra d'évoluer dans les
              environnements les plus hostiles
            </p>

            <div className="sousBranche__sousBrancheCont__logoCont">
              <div className="sousBranche__sousBrancheCont__logoCont__logo">
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef1, detailRef1)}
                    ref={logoRef1}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/GCE.png"
                      alt="logo des sous branches"
                    />
                    <h3>Groupe chasse embarqué</h3>
                    <div className="sousBrancheDetails" ref={detailRef1}>
                      <div className="detailTitle">
                        <h2>G.C.E</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef1)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef1} className="textCont">
                          <p>
                            Le Groupe Chasse Embarquée est constitué de
                            chasseurs légers et lourds, ainsi que de bombardiers
                            furtifs légers. Comme son nom l'indique, le groupe
                            est destiné à être embarqué dans les capitaux pour
                            être déployés sur de longues distances.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef2, detailRef2)}
                    ref={logoRef2}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/GAN.png"
                      alt="logo des sous branches"
                    />
                    <h3>Groupe aeronaval</h3>
                    <div className="sousBrancheDetails" ref={detailRef2}>
                      <div className="detailTitle">
                        <h2>G.A.N</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef2)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef2} className="textCont">
                          <p>
                            Le Groupe Aéronaval mobilise les vaisseaux capitaux
                            de combat sur différents types de missions spatiales
                            : blocus, escorte de navires civils ou
                            scientifiques, attaque de positions et de flottes
                            ennemies.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <span>
                  <div
                    onClick={() => openSousBrancheAnim(logoRef3, detailRef3)}
                    ref={logoRef3}
                    className="animCont"
                  >
                    <img
                      className="sousBranchelogo"
                      src="../../../images/vitrine/sousBrancheLogo/GAE.png"
                      alt="logo des sous branches"
                    />
                    <h3>Groupe d'attaque et escorte</h3>
                    <div className="sousBrancheDetails" ref={detailRef3}>
                      <div className="detailTitle">
                        <h2>G.A.E</h2>
                      </div>
                      <button onClick={() => closeSousBrancheAnim(detailRef3)}>
                        {" "}
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                      <div className="detailContent">
                        <div ref={detailTextRef3} className="textCont">
                          <p>
                            Le Groupe d'Attaque et d'Escorte est constitué de
                            vaisseaux multicrew lourds de combats mais dont la
                            taille est inférieure aux navires de classe Capital.
                            Toutes proportions gardées, ils sont plus maniables
                            et plus rapides et utilisent donc ces atouts pour
                            accomplir leurs missions.
                          </p>
                          {/* <a href="#">En savoir plus</a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Slide3;
